import { IStat } from ".";
import { IStatData } from "./stat.types";

export class Stat implements IStat {
    id?: string;
    name? : string;
    timestamp?: Date;
    granularity?: string;
    totalSaleVolume?: number;
    totalOrder?: number;
    totalCustomer?: number;
    productList?: Array<any>;
    orderList?: Array<any>;
    sale?: any;
    customer?: any;

    constructor(data: any){
        this.id = data.id;
        if(data.timestamp){
            this.timestamp = new Date(data.timestamp * 1000);
        }
        this.granularity = data.granularity;
        this.totalSaleVolume = data.totalSaleVolume;
        this.totalOrder = data.totalOrder;
        this.totalCustomer = data.totalCustomer;
        if(data.sale){
            this.sale = data.sale;
        }
        if(data.customer){
            this.customer = data.customer;
        }
        
        if(data.productList){
            this.productList = data.productList.map((x: any) => {
                switch (typeof x) {
                    case 'string':
                        return JSON.parse(x);
                    default:
                        return x;
                }
            });
        }
        if(data.orderList){
            this.orderList = data.orderList;
        }
    }

    data(): IStatData {
        return Object.assign({}, this);
    }
}